import { useEffect, useRef } from 'react';
import { useTwilioAppState } from '../state';
import useRoomState from '../hooks/useRoomState';

export default function AudioTrack({ track }) {
    const { activeSinkId } = useTwilioAppState();
    const roomState = useRoomState();
    const audioEl = useRef();

    useEffect(() => {
        setTimeout(() => {
            if (track.name && !document.getElementById(track.name)) {
                audioEl.current = track.attach();
                audioEl.current.setAttribute('id', track.name);
                document.body.appendChild(audioEl.current);
            }
        }, 0);
        return () => track.detach().forEach(el => el.remove());
    }, [track, roomState]);

    useEffect(() => {
        let didCancel = false;
        if (!didCancel) {
            if (audioEl && audioEl.current && audioEl.current.setSinkId)
                audioEl.current.setSinkId(activeSinkId);
        }
        return () => {
            didCancel = true;
        };
    }, [activeSinkId]);

    return null;
}